var _path, _rect, _rect2, _rect3, _rect4, _path2, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _path3, _rect23, _rect24, _rect25, _rect26, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 53,
    viewBox: "0 0 104 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.3158 0.281403H99.2632C101.647 0.281403 103.579 2.21365 103.579 4.59719V9.99193H86.3158V0.281403Z",
    fill: "#DADFF2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 69.0526,
    y: 0.281403,
    width: 17.2632,
    height: 9.71053,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 51.7895,
    y: 0.281403,
    width: 17.2632,
    height: 9.71053,
    fill: "#DADFF2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34.5263,
    y: 0.281403,
    width: 17.2632,
    height: 9.71053,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17.2632,
    y: 0.281403,
    width: 17.2632,
    height: 9.71053,
    fill: "#DADFF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.59704C0 2.21349 1.93224 0.28125 4.31579 0.28125H17.2632V9.99178H0V4.59704Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 86.3158,
    y: 9.99194,
    width: 17.2632,
    height: 10.7895,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 69.0526,
    y: 9.99194,
    width: 17.2632,
    height: 10.7895,
    fill: "#DADFF2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 51.7895,
    y: 9.99194,
    width: 17.2632,
    height: 10.7895,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 34.5263,
    y: 9.99194,
    width: 17.2632,
    height: 10.7895,
    fill: "#DADFF2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 17.2632,
    y: 9.99194,
    width: 17.2632,
    height: 10.7895,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    y: 9.99194,
    width: 17.2632,
    height: 10.7895,
    fill: "#DADFF2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 86.3158,
    y: 20.7814,
    width: 17.2632,
    height: 10.7895,
    fill: "#DADFF2"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 69.0526,
    y: 20.7814,
    width: 17.2632,
    height: 10.7895,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 51.7895,
    y: 20.7814,
    width: 17.2632,
    height: 10.7895,
    fill: "#DADFF2"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 34.5263,
    y: 20.7814,
    width: 17.2632,
    height: 10.7895,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 17.2632,
    y: 20.7814,
    width: 17.2632,
    height: 10.7895,
    fill: "#DADFF2"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    y: 20.7814,
    width: 17.2632,
    height: 10.7895,
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 86.3158,
    y: 31.5709,
    width: 17.2632,
    height: 10.7895,
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 69.0526,
    y: 31.5709,
    width: 17.2632,
    height: 10.7895,
    fill: "#DADFF2"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 51.7895,
    y: 31.5709,
    width: 17.2632,
    height: 10.7895,
    fill: "white"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 34.5263,
    y: 31.5709,
    width: 17.2632,
    height: 10.7895,
    fill: "#DADFF2"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 17.2632,
    y: 31.5709,
    width: 17.2632,
    height: 10.7895,
    fill: "white"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    y: 31.5709,
    width: 17.2632,
    height: 10.7895,
    fill: "#DADFF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3158 42.3604H103.579V47.7551C103.579 50.1386 101.647 52.0709 99.2632 52.0709H86.3158V42.3604Z",
    fill: "#DADFF2"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 69.0526,
    y: 42.3604,
    width: 17.2632,
    height: 9.71053,
    fill: "white"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 51.7895,
    y: 42.3604,
    width: 17.2632,
    height: 9.71053,
    fill: "#DADFF2"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 34.5263,
    y: 42.3604,
    width: 17.2632,
    height: 9.71053,
    fill: "white"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 17.2632,
    y: 42.3604,
    width: 17.2632,
    height: 9.71053,
    fill: "#DADFF2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 42.3604H17.2632V52.0709H4.31579C1.93224 52.0709 0 50.1386 0 47.7551V42.3604Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.f3c94ed783eda38bdfa38b4732a6954b.svg";
export { ForwardRef as ReactComponent };